module.exports = __webpack_public_path__ + "img/box-jazz.6de732f2.png";